"use strict";

// Progressbar Scroll
(() => {
  if (window.innerWidth >= 1024) return;
  if (typeof siteSettings !== "undefined" && siteSettings.isFrontPage) return;

  document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("header.header");
    if (!header) return;

    const progressBarContainer = document.createElement("div");
    progressBarContainer.id = "progress-container";
    progressBarContainer.style.display = "none";

    const progressBar = document.createElement("div");
    progressBar.id = "progress-bar";

    progressBarContainer.appendChild(progressBar);
    header.appendChild(progressBarContainer);

    const updateProgress = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      // показ / приховування
      progressBarContainer.style.display = scrollTop > 0 ? "block" : "none";

      if (docHeight <= 0) return;

      const progress = (scrollTop / docHeight) * 100;
      progressBar.style.width = progress + "%";
    };

    window.addEventListener("scroll", updateProgress, { passive: true });
  });
})();

// Animate Scroll
(() => {
  const header = document.querySelector("header");
  const getHeaderHeight = () => (header ? header.offsetHeight : 0);

  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const id = link.getAttribute("href");
    if (!id || id === "#") return;

    const target = document.querySelector(id);
    if (!target) return;

    e.preventDefault();

    const targetTop =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      getHeaderHeight();

    window.scrollTo({
      top: targetTop,
      behavior: "smooth",
    });
  });
})();

// Mobile Nav Toggle
(() => {
  const body = document.body;
  const burger = document.querySelector("button.burger");
  const nav = document.querySelector(".header-nav");

  if (!burger || !nav) return;

  burger.addEventListener("click", () => {
    body.classList.toggle("overflow-hidden");
    nav.classList.toggle("active");
    burger.classList.toggle("burger-active");
  });
})();

// Mobile SubNav open
(() => {
  const media = window.matchMedia("(max-width: 1024px)");
  const DURATION = 150;

  const header = document.querySelector(".header");
  if (!header) return;

  const items = header.querySelectorAll(
    ".genesis-nav-menu > ul > .menu-item"
  );
  if (!items.length) return;

  function initMobileMenu() {
    items.forEach((item) => {
      const submenu = item.querySelector(":scope > .sub-menu");
      if (!submenu) return;

      const link = item.querySelector(":scope > a");
      if (!link) return;

      item.classList.add("has-children");

      // зберігаємо href
      if (!link.dataset.originalHref) {
        link.dataset.originalHref = link.getAttribute("href");
      }

      // відключаємо перехід
      link.setAttribute("href", "#");

      // стилі анімації
      submenu.style.maxHeight = "0";
      submenu.style.overflow = "hidden";
      submenu.style.transition = `max-height ${DURATION}ms ease`;

      // уникаємо повторної ініціалізації
      if (!link.dataset.mobileInit) {
        link.addEventListener("click", function (e) {
          if (!media.matches) return;

          e.preventDefault();

          const isOpen = item.classList.contains("open");

          // закриваємо всі інші (опціонально, як accordion)
          items.forEach((i) => {
            if (i !== item) {
              i.classList.remove("open");
              const sm = i.querySelector(":scope > .sub-menu");
              if (sm) sm.style.maxHeight = "0";
            }
          });

          // toggle
          item.classList.toggle("open", !isOpen);

          if (isOpen) {
            submenu.style.maxHeight = "0";
          } else {
            submenu.style.maxHeight = submenu.scrollHeight + "px";
          }
        });

        link.dataset.mobileInit = "true";
      }
    });
  }

  function destroyMobileMenu() {
    items.forEach((item) => {
      const submenu = item.querySelector(":scope > .sub-menu");
      const link = item.querySelector(":scope > a");
      if (!submenu || !link) return;

      // повертаємо href
      if (link.dataset.originalHref) {
        link.setAttribute("href", link.dataset.originalHref);
      }

      // скидаємо стилі
      submenu.style.maxHeight = "";
      submenu.style.overflow = "";
      submenu.style.transition = "";

      item.classList.remove("open");
    });
  }

  function handleChange(e) {
    if (e.matches) {
      initMobileMenu();
    } else {
      destroyMobileMenu();
    }
  }

  // init
  if (media.matches) {
    initMobileMenu();
  }

  media.addEventListener("change", handleChange);
})();

// Social Share
(() => {
  const socialSpans = document.querySelectorAll(".social-share span");

  if (!socialSpans.length) return;

  socialSpans.forEach((span) => {
    span.addEventListener("click", () => {
      const link = span.dataset.link;
      const url = span.dataset.url;

      if (!link || !url) return;

      const fullUrl = "https://" + link + url;
      window.open(fullUrl, "_blank");
    });
  });
})();

// Popup
(() => {
  const popupFirst = document.querySelector(".popup-wrap-first");
  const popupSecond = document.querySelector(".popup-wrap-second");

  if (!popupFirst && !popupSecond) return;

  document.addEventListener("click", (e) => {
    if (e.target.closest(".show-popup-first")) {
      e.preventDefault();
      if (popupFirst) popupFirst.style.display = "flex";
      return;
    }

    if (e.target.closest(".show-popup-second")) {
      e.preventDefault();
      if (popupSecond) popupSecond.style.display = "flex";
      return;
    }

    const wrap = e.target.closest(".popup-wrap-first, .popup-wrap-second");

    if (e.target.closest(".close-popup") && wrap) {
      wrap.style.display = "none";
      return;
    }

    if (
      e.target.classList.contains("popup-wrap-first") ||
      e.target.classList.contains("popup-wrap-second")
    ) {
      e.target.style.display = "none";
    }
  });
})();

// history scroll
(() => {
  const wraps = [
    ...document.querySelectorAll(".company-history .company-history-wrap"),
  ];
  if (!wraps.length) return;

  const clamp = (v, min, max) => Math.min(Math.max(v, min), max);
  const lerp = (a, b, t) => a + (b - a) * t;
  const centerY = (rect) => rect.top + rect.height / 2;
  const state = new WeakMap();
  let raf = 0;
  const TRIGGER_VIEWPORT_RATIO = 0.45;

  const updateTargets = () => {
    const viewportTrigger = window.innerHeight * TRIGGER_VIEWPORT_RATIO;

    wraps.forEach((wrap) => {
      const points = [...wrap.querySelectorAll(".company-history-subtitle")];
      if (!points.length) {
        wrap.style.setProperty("--history-progress", "0px");
        wrap.style.setProperty("--history-line-start", "0px");
        wrap.style.setProperty("--history-line-max", "0px");
        return;
      }

      const wrapRect = wrap.getBoundingClientRect();
      const firstCenter = centerY(points[0].getBoundingClientRect());
      const lastCenter = centerY(
        points[points.length - 1].getBoundingClientRect(),
      );
      const lineStart = firstCenter - wrapRect.top;
      const lineMax = Math.max(lastCenter - firstCenter, 1);
      const targetFill =
        clamp((viewportTrigger - firstCenter) / lineMax, 0, 1) * lineMax;
      const pointCenters = points.map(
        (point) => centerY(point.getBoundingClientRect()) - wrapRect.top,
      );

      const prevState = state.get(wrap);
      state.set(wrap, {
        lineStart,
        lineMax,
        targetFill,
        currentFill: prevState ? prevState.currentFill : targetFill,
        points,
        pointCenters,
      });

      wrap.style.setProperty("--history-line-start", `${lineStart}px`);
      wrap.style.setProperty("--history-line-max", `${lineMax}px`);
    });

    if (!raf) raf = requestAnimationFrame(animate);
  };

  const animate = () => {
    let hasActiveAnimation = false;

    wraps.forEach((wrap) => {
      const wrapState = state.get(wrap);
      if (!wrapState) return;

      const nextFill = lerp(wrapState.currentFill, wrapState.targetFill, 0.2);
      const diff = Math.abs(wrapState.targetFill - nextFill);

      wrapState.currentFill = diff < 0.2 ? wrapState.targetFill : nextFill;
      if (diff >= 0.2) hasActiveAnimation = true;

      wrap.style.setProperty(
        "--history-progress",
        `${wrapState.currentFill}px`,
      );

      const activeEdge = wrapState.lineStart + wrapState.currentFill;
      wrapState.points.forEach((point, index) => {
        const pointCenterFromWrapTop = wrapState.pointCenters[index];
        point.classList.toggle(
          "is-active",
          pointCenterFromWrapTop <= activeEdge,
        );
      });
    });

    if (hasActiveAnimation) {
      raf = requestAnimationFrame(animate);
    } else {
      raf = 0;
    }
  };

  updateTargets();
  window.addEventListener("scroll", updateTargets, { passive: true });
  window.addEventListener("resize", updateTargets);
})();

document.addEventListener('DOMContentLoaded', () => {

  const lightboxTriggers = document.querySelectorAll('[ipsl-lightbox]');
  if (!lightboxTriggers.length) return;

  // ===== Overlay =====
  const overlay = document.createElement('div');
  Object.assign(overlay.style, {
    position: 'fixed',
    inset: '0',
    backgroundColor: '#000',
    opacity: '0',
    display: 'none',
    zIndex: '9998',
    transition: 'opacity 0.3s ease'
  });

  // ===== Close button =====
  const closeButton = document.createElement('button');
  closeButton.innerHTML = '×';

  Object.assign(closeButton.style, {
    position: 'fixed',
    top: '20px',
    right: '20px',
    zIndex: '10001',
    border: 'none',
    background: 'none',
    width: '40px',
    height: '40px',
    fontSize: '44px',
    lineHeight: '1',
    padding: '0',
    cursor: 'pointer',
    color: '#fff',
    display: 'none',
    opacity: '0',
    transition: 'opacity 0.3s ease'
  });

  // ===== Lightbox image =====
  const lightboxImg = document.createElement('img');
  Object.assign(lightboxImg.style, {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scale(0.9)',
    zIndex: '9999',
    display: 'none',
    maxWidth: '90%',
    maxHeight: '90%',
    opacity: '0',
    transition: 'all 0.3s ease',
    cursor: 'default'
  });

  document.body.appendChild(overlay);
  document.body.appendChild(closeButton);
  document.body.appendChild(lightboxImg);

  let isOpen = false;

  function openLightbox(src, alt = '') {
    if (!src) return;

    lightboxImg.src = src;
    lightboxImg.alt = alt;

    overlay.style.display = 'block';
    closeButton.style.display = 'block';
    lightboxImg.style.display = 'block';

    requestAnimationFrame(() => {
      overlay.style.opacity = '0.8';
      closeButton.style.opacity = '1';
      lightboxImg.style.opacity = '1';
      lightboxImg.style.transform = 'translate(-50%, -50%) scale(1)';
    });

    isOpen = true;
  }

  function closeLightbox() {
    if (!isOpen) return;

    overlay.style.opacity = '0';
    closeButton.style.opacity = '0';
    lightboxImg.style.opacity = '0';
    lightboxImg.style.transform = 'translate(-50%, -50%) scale(0.9)';

    setTimeout(() => {
      overlay.style.display = 'none';
      closeButton.style.display = 'none';
      lightboxImg.style.display = 'none';
      lightboxImg.src = '';
    }, 300);

    isOpen = false;
  }

  document.addEventListener('click', (e) => {

    const trigger = e.target.closest('[ipsl-lightbox]');
    if (!trigger) return;

    e.preventDefault();

    const imgSrc = trigger.getAttribute('ipsl-lightbox');
    const imgAlt = trigger.getAttribute('alt') || trigger.dataset.alt || '';

    openLightbox(imgSrc, imgAlt);
  });

  closeButton.addEventListener('click', closeLightbox);
  overlay.addEventListener('click', closeLightbox);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeLightbox();
  });

  lightboxImg.addEventListener('click', (e) => {
    e.stopPropagation();
  });

});


(() => {
  const counters = document.querySelectorAll(".counter");
  if (!counters.length) return;

  const observerOptions = {
    threshold: 0.5,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !entry.target.dataset.animated) {
        entry.target.dataset.animated = "true";

        const element = entry.target;
        const target = parseInt(element.getAttribute("data-target"));
        const suffix = element.getAttribute("data-suffix") || "";
        const duration = 2000;
        let startTime = null;

        const animate = (timestamp) => {
          if (!startTime) startTime = timestamp;

          const elapsed = timestamp - startTime;
          const progress = Math.min(elapsed / duration, 1);

          const easeProgress = 1 - Math.pow(1 - progress, 3);
          const currentValue = Math.floor(target * easeProgress);

          element.innerHTML = currentValue + suffix;

          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };

        requestAnimationFrame(animate);
        observer.unobserve(element);
      }
    });
  }, observerOptions);

  counters.forEach((counter) => {
    observer.observe(counter);
  });
})();